import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import PageNextJs from 'nextjs/PageNextJs';

const Advertise = dynamic(() => import('ui/pages/Advertise'), { ssr: false });

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/advertise">
      <Advertise/>
    </PageNextJs>
  );
};

export default Page;
